import "./ChannelCard.css";
import Button from "react-bootstrap/Button";
import { VerifiedTooltipLinkDark } from "../CustomCheckTooltips/CustomCheckTooltips";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faComment,
  faEdit,
  faEllipsisV,
  faList,
  faTimes,
  faTrophy,
  faUserCog,
  faVideo,
  faTimesCircle,
  faLink,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";
import { campaignFetcher, channelFetcher } from "../../../api/requests";
import { useState, useContext, useEffect, useCallback } from "react";
import LogoutModal from "../../Navigation/LogoutModal";
import { subscribersFetcher } from "../../../api/requests";
import { useToaster } from "../../../context/toaster";
import { ProfileContext } from "../../../context/profile";
import { Dropdown, NavDropdown, ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { baseURL } from "../../../api/dataFetcher";
import { useSelectedChannels } from "../../../context/selectedChannels";
import AddVideoToCampaignForm from "../../Homepage/AddVideoToCampaignForm";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { HeadingWrapper } from "../SectionHeader/SectionHeader";
import Modal from "../Modal";
import { AuthContext } from "../../../context/auth";
import LoadingIndicator from "../Loading/Loading";
import { CategoryContextProvider } from "../../../context/categories";
import { TagsContextProvider } from "../../../context/tag";
import Form from "react-bootstrap/Form";
import { ChannelContext } from "../../../context/channels";

function ChannelCard({
  imgSrc,
  imgAlt = "",
  imgHref = "#",
  views,
  channelName,
  subscriberCount,
  channelHref = "#",
  verified,
  isSubscribed,
  outline = false,
  mine = false,
  admin = false,
  videosId,
  channelId,
  onDelete,
  page,
  moreAdress,
  select,
  channelOwner,
  campaign = false,
  activeCampaign,
  videoViews,
  total_video_count,
}) {
  let buttonVariant;

  if (outline) {
    buttonVariant = isSubscribed ? "outline-secondary" : "outline-info";
  } else {
    buttonVariant = isSubscribed ? "secondary" : "info";
  }
  const [showDel, setShowDel] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [subscription, setSubscription] = useState();
  const { addMessage } = useToaster();
  const { profile } = useContext(ProfileContext);
  const { addChannel, removeChannel, isChannelSelected } =
    useSelectedChannels();
  const [showCampaignAdd, setShowCampaignAdd] = useState();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { user } = useContext(AuthContext);
  const [subscribeLoading, setSubscribeLoading] = useState(false);
  const [showAddRelatedChannels, setShowAddRelatedChannels] = useState(false);
  const [related, setRelated] = useState({
    open: false,
    value: {
      channelId: "",
      userId: "",
    },
    loading: false,
  });
  const { channels, isLoadingChannels } = useContext(ChannelContext);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [channelSearch, setChannelSearch] = useState("");
  const [relationLoading, setRelationLoading] = useState(false);
  const [showManagementRelatedChannels, setShowManagementRelatedChannels] =
    useState(false);
  const [relations, setRelations] = useState([]);

  const handleChannelSearch = async (value, relation = false) => {
    setChannelSearch(value);
    if (!value.trim()) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);

    try {
      let results = [];

      if (relation) {
        const [res1, res2] = await Promise.all([
          channelFetcher.getRelatedChannels({
            search: value,
            fromChannelId: channelId,
          }),
          channelFetcher.getRelatedChannels({
            search: value,
            toChannelId: channelId,
          }),
        ]);

        const combined = [...res1.results, ...res2.results];
        results = Array.from(new Map(combined.map((r) => [r.id, r])).values());
      } else {
        const res = await channelFetcher.searchChannels(value);
        results = res.results || [];
      }

      setSearchResults(results);
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClose = () => {
    setShowDel(false);
  };

  const handleDelete = async () => {
    try {
      const res = campaign
        ? await campaignFetcher.deleteCampaign(channelId)
        : await channelFetcher.delete(channelId);
      showToast(
        "success",
        campaign ? "كمپین با موفقیت حذف شد." : "کانال با موفقیت حذف شد."
      );
      setShowDel(false);
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubscribe = async () => {
    try {
      if (subscribed) {
        const res = campaign
          ? await campaignFetcher.unsubscribe(subscription?.results[0].id)
          : await subscribersFetcher.unsubscribe(subscription?.results[0].id);
        // if (res) {
        showToast("success", "لغو اشتراک با موفقیت انجام شد.");
        setSubscribed(false);
        setSubscription(null);
        // }
      } else {
        const res = campaign
          ? await campaignFetcher.subscribe(channelId)
          : await subscribersFetcher.subscribe(channelId);

        if (res) {
          showToast("success", "با موفقیت عضو شدید.");
          setSubscribed(true);
          const updatedSubscriptionData = campaign
            ? await campaignFetcher.isSubscribed(profile.user, channelId)
            : await subscribersFetcher.isSubscribed(profile.user, channelId);
          setSubscribeLoading(true);
          setSubscription(updatedSubscriptionData);
        } else {
          setSubscribeLoading(false);
        }
      }
    } catch (error) {
      showToast(
        "error",
        Object.values(error.response?.data)[0] ??
          "خطایی رخ داده است، دوباره تلاش کنید."
      );
    } finally {
      setSubscribeLoading(false);
    }
  };

  useEffect(() => {
    const checkSubscription = async () => {
      if (profile.user && channelId) {
        try {
          const subscriptionData = campaign
            ? await campaignFetcher.isSubscribed(profile.user, channelId)
            : await subscribersFetcher.isSubscribed(profile.user, channelId);
          setSubscribed(subscriptionData?.count > 0);
          setSubscription(subscriptionData);
        } catch (error) {
          console.error("Error checking subscription:", error);
          setSubscribed(false);
        }
      }
    };

    checkSubscription();
  }, [profile.user, channelId, campaign]);

  const handleChannelSelection = async () => {
    const willBeFavorite = !isChannelSelected(channelId);

    try {
      await channelFetcher.channelDescriptionEdit(
        {
          is_favorite: willBeFavorite,
          supervisor_to_favorited: user?.user_id,
          name: channelName,
          owner: channelOwner,
        },
        channelId
      );

      if (willBeFavorite) {
        addChannel({ id: channelId, name: channelName, owner: channelOwner });
        showToast("success", "به محبوب‌ها اضافه شد.");
      } else {
        removeChannel(channelId);
        showToast("success", "از محبوب‌ها حذف شد.");
      }
    } catch (error) {
      showToast(
        "error",
        error?.response?.data?.detail || "خطا در بروزرسانی محبوب‌ها"
      );
    }
  };

  const handleUploadClick = () => {
    setLoading(true);
  };

  const handleRelationRequest = async (toId) => {
    setRelationLoading(true);
    try {
      const res = await channelFetcher.postRelatedChannels({
        from_channel_id: channelId,
        to_channel_id: toId,
      });

      if (res.id) showToast("success", "درخواست با موفقیت ارسال شد.");
    } catch (err) {
      console.error(err);

      showToast("error", "ارسال درخواست با مشکل مواجه شد.");
    } finally {
      setRelationLoading(false);
    }
  };

  const getAllRelations = useCallback(async () => {
    if (!channelId) return;

    setRelationLoading(true);

    try {
      const [res1, res2] = await Promise.all([
        channelFetcher.getRelatedChannels({
          pageSize: 10000,
          fromChannelId: channelId,
        }),
        channelFetcher.getRelatedChannels({
          pageSize: 10000,
          toChannelId: channelId,
        }),
      ]);

      const combined = [...(res1?.results || []), ...(res2?.results || [])];
      const uniqueRelations = Array.from(
        new Map(combined.map((r) => [r.id, r])).values()
      );

      setRelations(uniqueRelations);
    } catch (error) {
      console.error("Error fetching related channels:", error);
      setRelations([]);
    } finally {
      setRelationLoading(false);
    }
  }, [channelId]);

  return (
    <>
      <div
        className="channels-card"
        style={{
          backgroundColor:
            mine && campaign && (activeCampaign ? "#fff" : "#eaeaea"),
        }}
        title={channelName ? channelName : ""}
      >
        {mine && (
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "-5px",
            }}
          >
            <ul className="navbar-nav pr-3">
              <NavDropdown
                className="no-arrow osahan-right-navbar-user user-dropdown-link"
                title={
                  <FontAwesomeIcon
                    color="#dfb46a"
                    icon={faEllipsisV}
                    fixedWidth
                  />
                }
              >
                <Link
                  to={
                    campaign
                      ? `/channel-edit/${channelId}/?campaign=true`
                      : `/channel-edit/${channelId}/`
                  }
                  className="dropdown-item textRight"
                  role="button"
                >
                  <FontAwesomeIcon icon={faEdit} fixedWidth />{" "}
                  {campaign ? "ویرایش پویش" : "ویرایش کانال"}
                </Link>
                {!admin && !campaign && (
                  <Link
                    to={`/choose-admin/${channelId}/`}
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faUserCog} fixedWidth /> انتخاب ادمین
                  </Link>
                )}
                {campaign ? (
                  <Link
                    onClick={() => setShowCampaignAdd(true)}
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faVideo} fixedWidth /> بارگزاری ویدئو
                  </Link>
                ) : (
                  <Link
                    to={`/upload/${channelId}/`}
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faVideo} fixedWidth /> بارگزاری ویدئو
                  </Link>
                )}
                <Link
                  to={
                    campaign
                      ? moreAdress + `?admin=${admin}&campaign=${campaign}`
                      : moreAdress + `?admin=${admin}`
                  }
                  className="dropdown-item textRight"
                  role="button"
                >
                  <FontAwesomeIcon icon={faVideo} fixedWidth /> مشاهده ویدئوها
                </Link>
                {campaign && user?.permissions?.includes("campaign_result") && (
                  <Link
                    to={`/set-campaign-result/${channelId}`}
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faTrophy} fixedWidth /> انتخاب نتیجه
                    پویش
                  </Link>
                )}
                {!campaign && (
                  <Link
                    to={`/single-channel/${channelId}#playlistCreation`}
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faVideo} fixedWidth /> ایجاد لیست پخش
                  </Link>
                )}
                {!campaign && (
                  <span
                    onClick={() => setShowAddRelatedChannels(true)}
                    className="dropdown-item textRight pointer"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faHandshake} fixedWidth /> درخواست
                    کانال هم سو
                  </span>
                )}
                {!campaign && (
                  <span
                    onClick={() => {
                      setShowManagementRelatedChannels(true);
                      getAllRelations();
                    }}
                    className="dropdown-item textRight pointer"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faHandshake} fixedWidth /> مدیریت
                    کانال های هم سو
                  </span>
                )}
                {!campaign && (
                  <Link
                    style={{ cursor: "not-allowed" }}
                    title="به زودی"
                    // to={`/upload`}
                    to=""
                    className="dropdown-item textRight"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faChartLine} fixedWidth /> اطلاعات
                    آماری
                  </Link>
                )}

                {!admin && (
                  <span
                    onClick={onDelete}
                    className="dropdown-item textRight textRed pointer"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faTimes} fixedWidth />{" "}
                    {campaign ? "حذف پویش" : "حذف کانال"}
                  </span>
                )}
              </NavDropdown>
            </ul>
          </div>
        )}
        <div className="channels-card-image">
          <a href={imgHref}>
            <div className="imgContainer">
              <div
                style={{
                  backgroundColor:
                    mine && campaign && (activeCampaign ? "green" : "red"),
                  width: "fit-content",
                  height: "fit-content",
                  borderRadius: "50%",
                  padding: "5px",
                }}
                title={
                  mine &&
                  campaign &&
                  (activeCampaign ? "پویش فعال است" : "پویش غیر فعال است")
                }
              >
                <img
                  className="img-fluid"
                  style={{
                    objectFit: "cover",
                    margin: mine && campaign && "0px",
                  }}
                  src={imgSrc ? baseURL + imgSrc : "/img/s1.png"}
                  alt={imgAlt}
                />
              </div>
            </div>
          </a>
          <div className="channels-card-image-btn">
            {!mine && (
              <Button
                onClick={handleSubscribe}
                variant="outline-info"
                size="sm"
              >
                {subscribeLoading ? (
                  <LoadingIndicator size="sm" />
                ) : subscribed ? (
                  "عضو هستید"
                ) : (
                  "عضو شوید"
                )}
              </Button>
            )}
          </div>
        </div>
        <div className="channels-card-body">
          <div className="channels-title">
            <a href={channelHref}>
              {channelName?.length > 60
                ? channelName.slice(0, 60) + "..."
                : channelName}{" "}
              {verified ? <VerifiedTooltipLinkDark /> : ""}
            </a>
          </div>
          <div className="channels-view">بازدید کانال:{views}</div>
          {videoViews ? (
            <div className="channels-view">بازدید ویدئوها:{videoViews}</div>
          ) : (
            ""
          )}
          {total_video_count ? (
            <div className="channels-view">
              تعداد ویدئوها:{total_video_count}
            </div>
          ) : (
            ""
          )}

          {select && (
            <Button
              style={{ fontSize: "14px", padding: "1px 5px", marginTop: "5px" }}
              onClick={() => handleChannelSelection(channelId)}
            >
              {isChannelSelected(channelId) ? "✓" : "انتخاب کانال"}
            </Button>
          )}
          {mine && (
            <a
              href={
                campaign
                  ? moreAdress + `?admin=${admin}&campaign=${campaign}`
                  : moreAdress + `?admin=${admin}`
              }
              className="channels-view"
            >
              مشاهده ویدئوها
            </a>
          )}
          <div
            style={{
              color: mine && campaign && (activeCampaign ? "green" : "red"),
            }}
          >
            {mine && campaign && (activeCampaign ? "فعال" : "غیرفعال")}
          </div>
        </div>
      </div>

      <Modal isOpen={showCampaignAdd} onClose={() => setShowCampaignAdd(false)}>
        <CategoryContextProvider>
          <TagsContextProvider>
            <AddVideoToCampaignForm
              handleUploadClick={handleUploadClick}
              loading={loading}
              setLoading={setLoading}
              campaignId={channelId}
              progress={progress}
              setProgress={setProgress}
            />
          </TagsContextProvider>
        </CategoryContextProvider>
        {loading && (
          <div
            style={{
              paddingTop: "30px",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            <hr />
            <Row>
              <Col lg={12}>
                <div className="rtlByMe">
                  <HeadingWrapper heading="بارگزاری جزئیات" />
                </div>
              </Col>
              <Col lg={2}>
                <div className="imgplace"></div>
              </Col>

              <Col lg={10} style={{ textAlign: "right" }}>
                <div className="osahan-title">در حال ارسال...</div>
                <div className="osahan-progress">
                  <ProgressBar striped animated now={progress} />

                  <div className="osahan-close">
                    <a
                      onClick={() => {
                        setLoading(false);
                        setProgress(0);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faTimesCircle} />
                    </a>
                  </div>
                </div>
                <div className="osahan-desc">
                  ویدئو درحال بارگزاری می باشد، لطفا صفحه را نبندید.
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Modal>

      <Modal
        isOpen={showAddRelatedChannels}
        onClose={() => setShowAddRelatedChannels(false)}
      >
        <div style={{ minHeight: "300px", padding: "10px" }}>
          <h4 style={{ marginBottom: "10px" }}>انتخاب کانال</h4>

          {/* Search Box */}
          <input
            type="text"
            placeholder="جستجو بر اساس نام کانال..."
            value={channelSearch}
            onChange={(e) => handleChannelSearch(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "13px",
              marginBottom: "10px",
            }}
          />

          {/* Channel List */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "6px",
              maxHeight: "250px",
              overflowY: "auto",
              background: "#fff",
            }}
          >
            {isLoadingChannels ? (
              <LoadingIndicator />
            ) : isSearching ? (
              <div style={{ padding: "10px" }}>در حال جستجو...</div>
            ) : (searchResults.length > 0
                ? searchResults
                : channels?.results || []
              ).length > 0 ? (
              (searchResults.length > 0
                ? searchResults
                : channels?.results
              )?.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    setRelated({
                      ...related,
                      value: { ...related.value, channelId: item.id },
                    });
                  }}
                  style={{
                    padding: "10px",
                    background:
                      related.value.channelId === item.id ? "#f0f0f0" : "#fff",
                    borderBottom: "1px solid #eee",
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "14px" }}>{item.name}</span>
                    <span style={{ fontSize: "12px", color: "#0fb2aa" }}>
                      (ID: {item.id})
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#0fb2aa",
                      color: "white",
                      padding: "4px 6px",
                      borderRadius: "5px",
                      marginTop: "6px",
                      width: "fit-content",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleRelationRequest(item.id)}
                  >
                    {relationLoading ? "در حال ارسال..." : "ارسال درخواست"}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: "10px",
                  color: "#888",
                  fontSize: "13px",
                  textAlign: "center",
                }}
              >
                نام کانال مورد نظر خود را جستجو کنید
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showManagementRelatedChannels}
        onClose={() => setShowManagementRelatedChannels(false)}
      >
        <div style={{ minHeight: "300px", padding: "10px" }}>
          <h4 style={{ marginBottom: "10px" }}>مدیریت کانال های هم سو</h4>

          {/* Search Box */}
          <input
            type="text"
            placeholder="جستجو بر اساس نام کانال..."
            value={channelSearch}
            onChange={(e) => handleChannelSearch(e.target.value, true)}
            style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "13px",
              marginBottom: "10px",
            }}
          />

          {/* Channel List */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "6px",
              maxHeight: "250px",
              overflowY: "auto",
              background: "#fff",
            }}
          >
            {isLoadingChannels ? (
              <LoadingIndicator />
            ) : isSearching ? (
              <div style={{ padding: "10px" }}>در حال جستجو...</div>
            ) : (searchResults.length > 0 ? searchResults : relations || [])
                .length > 0 ? (
              (searchResults.length > 0 ? searchResults : relations)?.map(
                (item) => (
                  <div
                    key={item.id}
                    style={{
                      padding: "10px",
                      background:
                        related.value.channelId === item.id
                          ? "#f0f0f0"
                          : "#fff",
                      borderBottom: "1px solid #eee",
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: "14px" }}>
                        {item.from_channel?.id === channelId
                          ? item.to_channel?.name
                          : item.from_channel?.name}
                      </span>
                      <span style={{ fontSize: "12px", color: "#0fb2aa" }}>
                        (ID:{" "}
                        {item.from_channel?.id === channelId
                          ? item.to_channel?.id
                          : item.from_channel?.id}
                        )
                      </span>
                    </div>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "6px",
                        padding: "4px 8px",
                        marginTop: "6px",
                        cursor: "pointer",
                        fontSize: "13px",
                        width: "fit-content",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          item.from_channel?.id === channelId
                            ? !item.is_hidden_for_from
                            : !item.is_hidden_for_to
                        }
                        disabled={relationLoading}
                        onChange={async () => {
                          try {
                            const currentHidden =
                              item.from_channel?.id === channelId
                                ? item.is_hidden_for_from
                                : item.is_hidden_for_to;

                            const res =
                              await channelFetcher.patchRelatedChannels(
                                item.id,
                                {
                                  is_hidden_for_from: !currentHidden,
                                  is_hidden_for_to: !currentHidden,
                                }
                              );

                            if (res) {
                              getAllRelations();
                              handleChannelSearch(channelSearch, true);
                            }
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                        style={{
                          width: "16px",
                          height: "16px",
                          accentColor: "#0fb2aa",
                          cursor: relationLoading ? "not-allowed" : "pointer",
                        }}
                      />
                      <span>
                        {relationLoading ? "در حال ارسال..." : "وضعیت درخواست"}
                      </span>
                    </label>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        backgroundColor: "#fffafa",
                        borderRadius: "6px",
                        padding: "4px 8px",
                        marginTop: "6px",
                        cursor: "pointer",
                        fontSize: "13px",
                        width: "fit-content",
                        color: "#a31414",
                        border: "1px solid #a31414",
                      }}
                      onClick={async () => {
                        setRelationLoading(true);
                        try {
                          const res =
                            await channelFetcher.deleteRelatedChannels(item.id);

                          getAllRelations();
                        } catch (err) {
                        } finally {
                          setRelationLoading(false);
                        }
                      }}
                    >
                      {relationLoading ? "در حال ارسال..." : "حذف درخواست"}
                    </span>
                  </div>
                )
              )
            ) : (
              <div
                style={{
                  padding: "10px",
                  color: "#888",
                  fontSize: "13px",
                  textAlign: "center",
                }}
              >
                نام کانال مورد نظر خود را جستجو کنید
              </div>
            )}
          </div>
        </div>
      </Modal>

      {showDel && (
        <LogoutModal
          show={showDel}
          type="delete"
          name={campaign ? "كمپین" : "کانال"}
          handleClose={handleClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
}

export default ChannelCard;
